function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pig_svg__cls-2{fill:#28ade3}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pig_svg___2_2",
  "data-name": 2.2
}, /*#__PURE__*/React.createElement("g", {
  id: "pig_svg___2_2c_outlines",
  "data-name": "2.2c_outlines"
}, /*#__PURE__*/React.createElement("path", {
  id: "pig_svg__slot",
  d: "M208.63 165.1h-15.75a2 2 0 000 4h15.75a2 2 0 000-4z",
  fill: "#80cdf2"
}), /*#__PURE__*/React.createElement("g", {
  id: "pig_svg__pig"
}, /*#__PURE__*/React.createElement("path", {
  className: "pig_svg__cls-2",
  d: "M253.68 178.08h-6.84a33.58 33.58 0 00-32-23.48h-28.19a33.47 33.47 0 00-26.33 12.81 7.72 7.72 0 00-12.38-2 3.76 3.76 0 11-5.32-5.32 2 2 0 00-2.83-2.83 7.76 7.76 0 1011 11A3.76 3.76 0 01157 172a2 2 0 00-.07.57 33.31 33.31 0 00-3.85 15.58v1a33.55 33.55 0 0018.3 29.85v15a5 5 0 004.95 4.95h11.14a5 5 0 004.95-4.95v-11.4h19.12v11.3a5 5 0 004.95 4.95h11.14a5 5 0 004.95-4.95v-16.41a33.67 33.67 0 0014.21-18.36h6.84a5 5 0 004.95-4.95V183a5 5 0 00-4.9-4.92zm-65.21 55.82a1 1 0 01-.95.95h-.67v-3.5a2 2 0 10-4 0v3.5H181v-3.5a2 2 0 10-4 0v3.5h-.67a1 1 0 01-.95-.95v-13.23a33.36 33.36 0 0011.22 1.94h1.82zm40.16 0a1 1 0 01-.95.95H227v-3.5a2 2 0 10-4 0v3.5h-1.8v-3.5a2 2 0 10-4 0v3.5h-.67a1 1 0 01-.95-.95v-11.31a33.3 33.3 0 0013-3zm-13.77-15.3h-28.21a29.56 29.56 0 01-29.52-29.52v-1a29.56 29.56 0 0129.52-29.52h28.21a29.56 29.56 0 0129.52 29.52v1a29.56 29.56 0 01-29.53 29.52zm39.77-24.43a1 1 0 01-.95.95h-5.86a33.56 33.56 0 00.56-6v-1a33.56 33.56 0 00-.56-6h5.86a1 1 0 01.95.95z"
}), /*#__PURE__*/React.createElement("path", {
  className: "pig_svg__cls-2",
  d: "M229.93 178.08a6.05 6.05 0 106.05 6.05 6.06 6.06 0 00-6.05-6.05zm0 8.11a2.05 2.05 0 112.05-2.05 2.06 2.06 0 01-2.05 2.04z"
}))));

function SvgPig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "130 150 140 60"
  }, props), _ref, _ref2);
}

export default SvgPig;